import { useLocale } from "../contexts/LocaleContext";

export function ImpressumPage() {
  const { t } = useLocale();

  return (
    <section className="wrapper">
      <h1>{t("impressum.title")}</h1>

      <p>
        <strong>{t("impressum.legalInfo")}</strong>
      </p>

      <p>
        Elke Schark Stiftung
        <br />
        Diepoldsauerstrasse 20
        <br />
        9443 Widnau
        <br />
        Schweiz
      </p>

      <p>
        E-Mail:{" "}
        <a href="mailto:bm@elke-schark-stiftung.com">
          bm@elke-schark-stiftung.com
        </a>
      </p>

      <p>
        {t("impressum.contactPerson")}
        <br />
        Bernhard Mailinger
      </p>

      <p>
        {t("impressum.bankDetails")}
        <br />
        Elke Schark Stiftung
        <br />
        Raiffeisenbank Mittelrheintal
        <br />
        CH61 8080 8001 5163 8322 5
        <br />
        SWIFT-BIC: RAIFCH22
      </p>

      <p>
        <b>{t("impressum.contentLiability")}</b>
        <br />
        {t("impressum.contentLiabilityText")}
      </p>

      <p>
        <b>{t("impressum.linkLiability")}</b>
        <br />
        {t("impressum.linkLiabilityText")}
      </p>
    </section>
  );
}
